const hasStableValue = (value) => value !== null && value !== undefined;

const getStableEntityId = (entity) => {
  if (entity === null || entity === undefined) {
    return null;
  }

  const stableId = entity.id ?? entity.shortID;
  return hasStableValue(stableId) ? stableId : null;
};

const getScopedSortableId = (prefix, entity, scopeId) => {
  const stableId = getStableEntityId(entity);
  if (!hasStableValue(stableId)) {
    return null;
  }

  const scope = scopeId ?? entity?.parentGroupId ?? entity?.parentGroupUUID ?? "unscoped";
  return `${prefix}-${scope}-${stableId}`;
};

const getPanelSortableId = (panel, index) => {
  if (panel === null || panel === undefined) {
    return null;
  }

  const panelType = panel.type ?? "unknown";
  const stableId = getStableEntityId(panel);

  if (hasStableValue(stableId)) {
    return `sidebar-panel-${panelType}-${stableId}`;
  }

  return `sidebar-panel-${panelType}-${index}`;
};

const getSubGroupSortableId = (subGroup, parentGroupId) => getScopedSortableId("sidebar-subgroup", subGroup, parentGroupId);

const getModelSortableId = (model, collectionId) => getScopedSortableId("sidebar-model", model, collectionId);

const findSortableIndex = (items, sortableId, getSortableId) => {
  if (!Array.isArray(items) || !hasStableValue(sortableId) || typeof getSortableId !== "function") {
    return -1;
  }

  return items.findIndex((item, index) => getSortableId(item, index) === sortableId);
};

export { findSortableIndex, getModelSortableId, getPanelSortableId, getSubGroupSortableId };
